"use client";

import { useWindowSearchParams } from "@/hooks/use-window-search-params";
import { useMemo } from "react";

import type { UtmTracking } from "@convex/schemas/validators/tracking";
export type { UtmTracking } from "@convex/schemas/validators/tracking";

export function readUtmFromSearchParams(
  searchParams: URLSearchParams,
): UtmTracking {
  const get = (key: string): string | undefined =>
    searchParams.get(key) ?? undefined;

  return {
    utmId: get("utm_id"),
    adAccountId: get("utm_account_id"),
    campaignId: get("utm_id") ?? get("gad_campaignid"),
    adSetId: get("utm_adset_id"),
    adId: get("utm_ad_id"),
    utmSource: get("utm_source"),
    utmMedium: get("utm_medium"),
    utmCampaign: get("utm_campaign"),
    utmTerm: get("utm_term"),
    utmContent: get("utm_content"),
    gclid: get("gclid"),
    gbraid: get("gbraid"),
    wbraid: get("wbraid"),
    gadSource: get("gad_source"),
    fbclid: get("fbclid"),
    msclkid: get("msclkid"),
    ttclid: get("ttclid"),
    liFatId: get("li_fat_id"),
  };
}

export function useUtmTracking(): UtmTracking {
  const searchParams = useWindowSearchParams();
  return useMemo(() => readUtmFromSearchParams(searchParams), [searchParams]);
}

export function hasUtmParams(utm: UtmTracking): boolean {
  return Object.values(utm).some((v) => v !== undefined);
}
